export default __webpack_public_path__ + "static/media/UMCP.dbd85be0.webp";